import React, { forwardRef, useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { withTranslation } from "react-i18next";
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  buttonOutlined: {
    border: "2px solid",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 150,
    minHeight: 50
  },
}));

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const DialogCustomComponent = ({
  open: openProp,
  handleClose: handleCloseProp,
  title,
  children,
  handleSave,
  showBtnConfirmSlot,
  handleSaveSlot,
  slotSaveLoading = false,
  t,
  showBtnSave = true
}) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  useEffect(() => {
    if (open !== openProp) setOpen(openProp);
  }, [openProp]);

  const handleClose = () => {
    handleCloseProp();
    setOpen(false);
  };

  const handleSaveModal = () => {
    setOpen(false);
    handleSave();
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle style={{ width: 500 }} id="alert-dialog-slide-title">
        <Typography variant="h4">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {children}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {
          showBtnConfirmSlot == true ? (
            <Button
              onClick={() => { handleSaveSlot() }}
              variant="outlined"
              className={classes.buttonOutlined}
              color="#000"
              disabled={slotSaveLoading}
            >
              {slotSaveLoading ? (
                <CircularProgress color="primary" />
              ) : t("confirm")}
            </Button>) : ""
        }

        <Button onClick={handleClose}
          variant="outlined"
          className={classes.buttonOutlined}>
          {t("cancel")}
        </Button>
        {showBtnSave && <Button onClick={handleSaveModal} color="primary">
          {t("save")}
        </Button>}
      </DialogActions>
    </Dialog>
  );
};

const DialogCustom = withTranslation()(DialogCustomComponent);

export { DialogCustom };
